/**
 * 系统键盘转换器
 * 定义 Windows 和 Mac 键盘之间的差异转换规则
 * 只需维护一份 Windows 基础配置，Mac 配置通过转换规则自动生成
 */



/**
 * 将 Windows 键盘配置转换为 Mac 键盘配置
 * @param {Array} windowsKeyboard - Windows 键盘配置数组
 * @returns {Array} Mac 键盘配置数组
 */
export function transformToMac(windowsKeyboard) {
  // 深拷贝以避免修改原始数据
  const macKeyboard = JSON.parse(JSON.stringify(windowsKeyboard));

  // 需要进行转换的修饰键映射规则
  const macModifierKeysMapping = {
    1: { name: "Opt", code: "AltLeft", keyCode: 226 },
    2: { name: "Cmd", code: "MetaRight", keyCode: 227 },
    3: { name: "Cmd", code: "MetaLeft", keyCode: 227 },
    4: { name: "Opt", code: "AltRight", keyCode: 230 }
  };

  // 遍历 windowsKeyboard，根据 transformId 替换 name, code, keyCode
  macKeyboard.forEach(key => {
    if (key.transformId) {
      const mapping = macModifierKeysMapping[key.transformId];
      if (mapping) {
        key.name = mapping.name;
        key.code = mapping.code;
        key.keyCode = mapping.keyCode;
      }
    }
  });

  return macKeyboard;
}

/**
 * 将 Mac 键盘配置转换为 Windows 键盘配置
 * @param {Array} macKeyboard - Mac 键盘配置数组
 * @returns {Array} Windows 键盘配置数组
 */
export function transformToWindows(macKeyboard) {
  // Mac → Windows 是反向转换，这里暂不实现
  // 因为基础配置就是 Windows，不需要反向转换
  return macKeyboard
}

/**
 * 根据系统类型应用转换
 * @param {Array} baseKeyboard - 基础键盘配置（Windows）
 * @param {string} system - 目标系统: 'windows' | 'mac'
 * @returns {Array} 转换后的键盘配置
 */
export function applySystemTransform(baseKeyboard, system) {
  if (system === 'mac') {
    return transformToMac(baseKeyboard)
  }
  // Windows 直接返回基础配置
  return baseKeyboard
}
